/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';
import * as React from 'react';

import type { TextareaProps } from '../../types';
import './Textarea.less';

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ size = 'medium', invalid = false, className, disabled, rows = 4, ...rest }, ref) => {
    return (
      <span
        className={cx(
          'textarea',
          `textarea--${size}`,
          {
            'textarea--invalid': invalid,
            'textarea--disabled': disabled,
          },
          className
        )}>
        <textarea ref={ref} disabled={disabled} rows={rows} className="textarea__field" {...rest} />
      </span>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;
